export const TOAST_TYPE: Record<string, string> = {
  success: '#38F24A',
  error: '#D64C45',
  loading: 'white',
};
